import * as moment from 'moment';

declare var mixpanel;
export class BrowserStorageUtil {

    static authRelatedKeys = ['authResponse','loginSessionEndTime', 'Token', 'User2', 'isLoginFromVision', 'isStripUser', 'manufacturingLocation', 'isQMSTrailModelShown', 'userHeaderLogo', 'LoggedId', 'applicableRoles', 'loggedCompanyId', 'LoggedIdEncript', 'isNewUser', 'Usertype', 'isMqsEnabled','AccountType', 'IsPremium', 'AccountType', 'isCapabilitiesFilled', 'isCompanyProfileFilled', 'profileComplete', 'isEmailVerified', 'StripeCustomerId', 'employeeCountRangeId','totalLoginCount', 'widget_api_key']

    /* --- TEMP-SUPPLIER-DASHBOARD-TILES-TEST begin (grep repo tag; remove with test-dashboard-tiles/ + dashboard hooks) --- */
    /** Cached JSON from Supplier/GetSupplierDynamicTilesIntentScoring (dev/test tools). */
    static readonly keySupplierDynamicTilesIntentScoring = 'supplierDynamicTilesIntentScoring';

    /**
     * Resolves supplier company id for dashboard/tile APIs (same rules as supplier dashboard tile feed).
     */
    static getSupplierCompanyIdForDashboard(): number | null {
        let raw: string | number | null = this.getItem('supplier_company_id') || this.getItem('loggedCompanyId');
        if (!raw) {
            try {
                const iContact = JSON.parse(this.getItem('iContactViewModel') || 'null');
                raw = iContact?.company?.companyId ?? iContact?.companyId ?? null;
            } catch {
                raw = null;
            }
        }
        if (raw == null || raw === '') {
            return null;
        }
        const id = typeof raw === 'number' ? raw : parseInt(String(raw), 10);
        return isNaN(id) ? null : id;
    }

    static setSupplierDynamicTilesIntentScoringJson(json: string): void {
        this.setItem(this.keySupplierDynamicTilesIntentScoring, json);
    }

    static getSupplierDynamicTilesIntentScoringJson(): string | null {
        const v = this.getItem(this.keySupplierDynamicTilesIntentScoring);
        return v != null && v !== '' ? v : null;
    }

    /** Removes intent JSON stored in native `localStorage` (dashboard test override). */
    static clearSupplierDynamicTilesIntentScoringLocalStorage(): void {
        try {
            browserWindow.localStorage?.removeItem(this.keySupplierDynamicTilesIntentScoring);
        } catch {
            // ignore
        }
    }
    /* --- TEMP-SUPPLIER-DASHBOARD-TILES-TEST end --- */

    static getCommpanyId() {
        return this.getItem('loggedCompanyId');
    }
    static getLoogedUserEmail() {
        return this.getItem('User2');
    }
    static getLoogedUserId() {
        return parseInt(this.getItem('LoggedId'));
    }
    static isValidatedBuyer() {
        return this.getItem('isEmailVerify');
    }
    static getLoogedUserType() {
        return this.getItem('Usertype');
    }
    static getiContactViewModel() {
        return JSON.parse(this.getItem('iContactViewModel'));
    }
    static getiWillDoLater() {
        return this.getItem("WillDoLater")
    }
    static getiSubmitedRfqCount() {
        return Number(this.getItem("submitRfqCount"));
    }
    static getMixpanelIdentification() {
        return Number(this.getItem("mpi"));
    }
    static setMixpanelIdentification() {
        this.setItem("mpi", this.getItem('LoggedId'));
    }
    static setValueInLocalStorage(key, value) {
        this.setItem(key, value);
    }

    static getJSON(key) {
        return JSON.parse(this.getItem(key));
    }

    // Recursive function to get the value of a key in a nested object
    static getInObj(obj: any, key: string): any {
        if (obj == null || typeof obj !== 'object') {
            return undefined;
        }

        if (obj.hasOwnProperty(key)) {
            return obj[key];
        }

        for (const k in obj) {
            if (obj.hasOwnProperty(k)) {
                const result = this.getInObj(obj[k], key);
                if (result !== undefined) {
                    return result;
                }
            }
        }
        return undefined;
    }
    static getLoginSessionEndTime() {
        return Number(this.getItem("loginSessionEndTime"));
    }
    static setLoginSessionEndTime() {
        this.setItem("loginSessionEndTime", moment(moment.utc().toDate()).add(24, 'hours').unix().toString());
    }
    static setRefreshToken(refreshToken) {
        this.setItem("refreshToken", refreshToken);
    }
    static getRefreshToken() {
        return this.getItem("refreshToken");
    }
    static setToken(token) {
        this.setItem("Token", token);
    }

    static setItem(key, value) {
        if (this.authRelatedKeys.indexOf(key)> -1) {
            try {
                const days = 7; // Set cookie expiry to 7 day
                this.setCookie(key, value, days);
            } catch (ex) {
                console.log(ex);
            }
        } else {
          temporaryStorage.setItem(key, value);
        }
    }

    static clear() {
        if (isLocalStorageAvailable) {
            this.clearCookies();
        } else {
            temporaryStorage.storage = {};
        }
    }

    static removeItem(key) {
        if (isLocalStorageAvailable) {
            this.eraseCookie(key);
        } else {
            temporaryStorage[key] = null;
        }
    }

    static getItem(key) {
        if (isLocalStorageAvailable && this.authRelatedKeys.indexOf(key)> -1) {
            return this.getCookie(key);
        }
        else {
            return temporaryStorage.getItem(key);
        }
    }

    static setSessionItem(key, value) {

        temporarySessionStorage.setItem(key, value);
    }

    static getSessionItem(key) {
        return temporarySessionStorage.getItem(key);
    }

    static clearSession(){
        temporarySessionStorage.storage = {};
    }

    static removeSessionItem(key){
        temporarySessionStorage[key]=null;
    }

    static isLocalStorageAvailable() {
        // var test = 'test';
        // var returnValue = false;
        // try {
        //     browserWindow.localStorage.setItem(test, test);
        //     if (browserWindow.localStorage.getItem(test) === "test") {
        //         returnValue = true;
        //     }
        //     browserWindow.localStorage.removeItem(test);
        //     return returnValue;
        // } catch (e) {
        //     return false;
        // }
        return true;
    }

    static getToken() {
        return this.getItem('Token');
    }

    static logout() {
        browserWindow.setTimeout(function () {
            if (mixpanel?.cookie && mixpanel?.cookie?.clear) {
                if (mixpanel?.reset) {
                    mixpanel.reset();
                }
                mixpanel.cookie.clear();
            }
            console.log('logout redirection called.');
            browserWindow.location.href = '/';
        }, 200);
        this.clearCookies();
        this.clear();
        this.clearSession();
        this.clearSupplierDynamicTilesIntentScoringLocalStorage(); // TEMP-SUPPLIER-DASHBOARD-TILES-TEST: delete with storage helpers above
    }

    static setCookie(name, value, days?) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    static getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    static eraseCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999; path=/';
    }

    static clearCookies() {
        for (let key of this.authRelatedKeys) {
            this.eraseCookie(key);
        }
    }
}


